import { createContext, useRef, useState } from 'react';
import styled from 'styled-components';
import { ANIMATION_DELAY_MS, ANIMATION_DURATION_MS } from '../../utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledContentWrapper = styled.div.withConfig({
  displayName: "ContentWrapper__StyledContentWrapper",
  componentId: "sc-1jqjds5-0"
})(["transition:opacity ", " ease-in-out ", ";opacity:", ";"], ANIMATION_DURATION_MS, ANIMATION_DELAY_MS, props => props.opacity);
export const StoreContext = /*#__PURE__*/createContext(undefined);
export const ContentWrapper = ({
  children
}) => {
  const [opacity, setOpacity] = useState('1');
  const api = useRef({
    setOpacity
  });

  //@bend-expect trellis-tokenized
  return /*#__PURE__*/_jsx(StoreContext.Provider, {
    value: api.current,
    children: /*#__PURE__*/_jsx(StyledContentWrapper, {
      opacity: opacity,
      className: "opacity-container",
      "data-test-id": "opacity-container",
      children: children
    })
  });
};